import { Button } from '@heroui/react';
import React from 'react';

export interface FormFooterProps {
  /**
   * Text for the save button
   * @default "Save"
   */
  saveText?: string;
  /**
   * Text for the cancel button
   * @default "Cancel"
   */
  cancelText?: string;
  /**
   * Callback function when save button is clicked
   */
  onSave: () => void;
  /**
   * Callback function when cancel button is clicked
   */
  onCancel: () => void;
  /**
   * Whether the save operation is in progress
   * @default false
   */
  isSaving?: boolean;
  /**
   * Whether the save button should be disabled
   * @default false
   */
  isSaveDisabled?: boolean;
  /**
   * Whether the cancel button should be disabled
   * @default false
   */
  isCancelDisabled?: boolean;
  /**
   * Additional CSS classes for the container
   */
  className?: string;
  /**
   * Whether the save button should be loading
   * @default false
   */
  isSaveLoading?: boolean;
}

export const FormFooter: React.FC<FormFooterProps> = ({
  saveText = 'Save',
  cancelText = 'Cancel',
  onSave,
  onCancel,
  isSaving = false,
  isSaveDisabled = false,
  isCancelDisabled = false,
  isSaveLoading = false,
  className = '',
}) => {
  return (
    <div
      className={`flex justify-end gap-4 pt-4 border-t border-divider ${className}`}
    >
      <Button
        variant="bordered"
        onPress={onCancel}
        isDisabled={isCancelDisabled || isSaving}
        className={
          isCancelDisabled || isSaving ? 'opacity-50 cursor-not-allowed' : ''
        }
      >
        {cancelText}
      </Button>
      <Button
        color="primary"
        onPress={onSave}
        isLoading={isSaveLoading}
        isDisabled={isSaveDisabled}
        className={
          isSaveDisabled && !isSaving ? 'opacity-50 cursor-not-allowed' : ''
        }
      >
        {saveText}
      </Button>
    </div>
  );
};
